// Validated categorical palette (fixed order - never cycled/reordered per
// series count, see dataviz skill's color-formula.md). Worst adjacent CVD
// ΔE 24.2, confirmed via scripts/validate_palette.js. Three slots
// (aqua/yellow/magenta) sit below 3:1 contrast on a light surface, so any
// chart using them ships direct value labels (the "relief rule"), never
// relies on the fill color alone to carry the number.
export const CATEGORICAL = [
  '#2a78d6', // 1 blue
  '#1baf7a', // 2 aqua
  '#eda100', // 3 yellow
  '#008300', // 4 green
  '#4a3aa7', // 5 violet
  '#e34948', // 6 red
  '#e87ba4', // 7 magenta
  '#eb6834', // 8 orange
];

export const INK = { primary: '#0b0b0b', secondary: '#52514e', muted: '#898781', grid: '#e1e0d9' };
